import styles from './ChartBox.module.scss'

const ChartBox = ({ children, noWrapper }) => (
  <div className={noWrapper ? styles.noWrapper : styles.wrapper}>{children}</div>
)

const Header = ({ title, subtitle, children }) => (
  <div className={styles.header}>
    <div>
      {title && <div className={styles.title}>{title}</div>}
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
    </div>
    {children}
  </div>
)

const Content = ({ children }) => <div className={styles.content}>{children}</div>

ChartBox.Header = Header
ChartBox.Content = Content

export default ChartBox
